// Shared constants, types, and utilities across all RCT apps

export const SITE_NAME = 'RidgeCodeTech LLC';
export const CONTACT_EMAIL = 'hello@ridgecodetech.com';

export const NAV_LINKS = [
  { href: '#services', label: 'Services' },
  { href: '#stack',    label: 'Stack' },
  { href: '#about',    label: 'About' },
  { href: '#contact',  label: 'Contact' },
] as const;

export const FOOTER_LINKS = [
  { href: 'https://custom.ridgecodetech.com',      label: 'Custom' },
  { href: 'https://consulting.ridgecodetech.com',  label: 'Consulting' },
  { href: 'https://ai.ridgecodetech.com',          label: 'AI' },
  { href: 'https://web.ridgecodetech.com',         label: 'Web' },
  { href: 'https://intern.ridgecodetech.com',      label: 'Intern' },
] as const;

export const WORKER_URL = 'https://contact.ridgecodetech.com';
export const AGENT_URL  = 'https://agent.ridgecodetech.com';

// Brand colors — matches CSS vars
export const COLORS = {
  navy:       '#0f264f',
  navyDeep:   '#091a38',
  navyMid:    '#1a3a6e',
  periwinkle: '#becdea',
  steel:      '#7a96c1',
  pale:       '#e1ecff',
  offWhite:   '#f5f8ff',
} as const;

// Utility: simple email validator
export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

// Utility: escape HTML for safe insertion
export function escapeHtml(str: string): string {
  return str
    .replace(/&/g,  '&amp;')
    .replace(/</g,  '&lt;')
    .replace(/>/g,  '&gt;')
    .replace(/"/g,  '&quot;')
    .replace(/'/g,  '&#x27;');
}
